var map = {
	".": 7672,
	"./": 7672,
	"./App": 1193,
	"./App.css": 3508,
	"./App.tsx": 1193,
	"./assets/questions": 8976,
	"./assets/questions.tsx": 8976,
	"./components/CurrentResult": 982,
	"./components/CurrentResult.tsx": 982,
	"./components/FinalResult": 6953,
	"./components/FinalResult.tsx": 6953,
	"./components/GeneralInfo": 3327,
	"./components/GeneralInfo.tsx": 3327,
	"./components/HomePage": 7416,
	"./components/HomePage.tsx": 7416,
	"./components/Question": 1459,
	"./components/Question.tsx": 1459,
	"./fonts/FiraGO-Bold.otf": 4322,
	"./fonts/FiraGO-Book.otf": 4652,
	"./fonts/FiraGO-Medium.otf": 8208,
	"./imgs/chart.svg": 9720,
	"./imgs/home-girl-boy.svg": 8265,
	"./imgs/house.svg": 2998,
	"./imgs/question_bg1.svg": 3971,
	"./imgs/question_bg10.svg": 7802,
	"./imgs/question_bg11.svg": 8852,
	"./imgs/question_bg12.svg": 7989,
	"./imgs/question_bg13.svg": 9001,
	"./imgs/question_bg14.svg": 7494,
	"./imgs/question_bg15.svg": 4781,
	"./imgs/question_bg16.svg": 2770,
	"./imgs/question_bg17.svg": 4943,
	"./imgs/question_bg18.svg": 6838,
	"./imgs/question_bg19.svg": 7203,
	"./imgs/question_bg2.svg": 7667,
	"./imgs/question_bg20.svg": 7714,
	"./imgs/question_bg21.svg": 5495,
	"./imgs/question_bg3.svg": 3362,
	"./imgs/question_bg4.svg": 146,
	"./imgs/question_bg5.svg": 7482,
	"./imgs/question_bg6.svg": 9131,
	"./imgs/question_bg7.svg": 164,
	"./imgs/question_bg8.svg": 1945,
	"./imgs/question_bg9.svg": 5068,
	"./imgs/result_bg1.svg": 4839,
	"./imgs/result_bg2.svg": 8913,
	"./imgs/result_bg3.svg": 1494,
	"./imgs/result_bg4.svg": 107,
	"./index": 7672,
	"./index.css": 1174,
	"./index.tsx": 7672,
	"./logo.svg": 1100,
	"./models/AnswerOption": 1797,
	"./models/AnswerOption.tsx": 1797,
	"./models/QuestionModel": 3488,
	"./models/QuestionModel.tsx": 3488,
	"./react-app-env.d": 4398,
	"./react-app-env.d.ts": 4398,
	"./reportWebVitals": 8983,
	"./reportWebVitals.ts": 8983,
	"./setupTests": 2887,
	"./setupTests.ts": 2887
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 407;